<template>
  <v-card class="portal-form-card" elevation="2" variant="outlined">
    <v-card-text class="pa-6">
      <div class="card-header mb-4">
        <h3 class="card-title text-h6 font-weight-medium text-primary">
          {{ portalForm.description }}
        </h3>
      </div>

      <div class="card-content">
        <div class="form-details">
          <div v-if="portalForm.directions" class="detail-section mb-3">
            <div class="detail-value">{{ portalForm.directions }}</div>
          </div>

          <div v-if="portalForm.plans && portalForm.plans.length" class="detail-section mb-3">
            <v-expansion-panels variant="accordion" class="detail-expansion">
              <v-expansion-panel>
                <v-expansion-panel-title class="py-2 px-0">
                  <span class="text-body-2 text-medium-emphasis">Click to view plans included</span>
                  <template #actions>
                    <v-icon icon="mdi-chevron-down"></v-icon>
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text class="px-0">
                  <div v-if="portalForm.plans && portalForm.plans.length" class="detail-list">
                    <div v-for="(plan, index) in portalForm.plans" :key="index" class="detail-item">
                      {{ plan }}
                    </div>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="pa-6 pt-0">
      <div v-if="props.selected" class="action-buttons">
        <v-btn
          variant="outlined"
          color="primary text-success font-weight-medium"
          prepend-icon="mdi-checkbox-marked"
          disabled="">
          Active Form
        </v-btn>
      </div>
      <div v-if="!props.selected" class="action-buttons">
        <v-btn
          variant="outlined"
          color="primary"
          prepend-icon="mdi-swap-horizontal"
          @click="emit('changeFormSelection', portalForm)">
          Change Form
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  portalForm: {
    type: Object,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

const portalForm = ref(props.portalForm);
const emit = defineEmits(["changeFormSelection"]);
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/typography.scss";
@import "@/styles/components/_portal-form-detail-card.scss";
</style>
